import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertLogLevel, AlertLogStatus } from '@app/shared/models/alert-log.model';
import { AlertLog } from '@app/shared/interfaces/alert-log.interface';
import { Subscription } from 'rxjs';
import { Color } from '@app/shared/models/color.model';
import { AlertLogService } from '@app/components/alert-log/alert-log.service';
import { getAlertCategory } from '@app/shared/utils/alerts-log';
import { Size } from '@app/shared/components/atoms/icon/icon.component';
import { LoaderService } from '@app/shared/services/loader.service';

@Component({
  selector: 'app-error-log',
  templateUrl: './error-log.component.html',
  styleUrls: ['./error-log.component.scss'],
  standalone: false,
})
export class ErrorLogComponent implements OnInit, OnDestroy {
  alertsSource: AlertLog[] = [];

  protected readonly alertLogLevel = AlertLogLevel;

  alertsData: { [key: string]: { errors: number; warnings: number } } = {};

  error: boolean = false;

  loading: boolean = true;

  errorCounter: number = 0;

  warningCounter: number = 0;

  alertsRequest?: Subscription;

  protected readonly Color = Color;

  protected readonly Size = Size;

  constructor(
    private alertLogService: AlertLogService,
    private loaderService: LoaderService,
  ) {}

  ngOnInit() {
    this.getAlerts();
  }

  getAlerts(): void {
    this.loaderService.show('half');
    this.loading = true;
    this.alertsRequest = this.alertLogService.getAlertsLog({ status: AlertLogStatus.TODO }).subscribe({
      next: (response) => {
        this.loading = false;
        this.loaderService.hide();
        this.processAlerts(response.Items);
      },
      error: (error) => {
        console.error('Erreur lors de la récupération des alertes', error);
        this.error = true;
        this.loaderService.hide();
        this.loading = false;
      },
    });
  }

  private processAlerts(items: AlertLog[]): void {
    this.alertsSource = items;
    this.alertsData = {};
    this.errorCounter = 0;
    this.warningCounter = 0;

    items.forEach((item) => {
      const alertCategory = getAlertCategory(item.category);
      if (!this.alertsData[alertCategory]) {
        this.alertsData[alertCategory] = { errors: 0, warnings: 0 };
      }

      if (item.level === AlertLogLevel.ERROR) {
        this.alertsData[alertCategory].errors += 1;
        this.errorCounter += 1;
      } else if (item.level === AlertLogLevel.WARNING) {
        this.alertsData[alertCategory].warnings += 1;
        this.warningCounter += 1;
      }
    });

    // Supprime les catégories vides
    Object.keys(this.alertsData).forEach((category) => {
      if (this.alertsData[category].errors === 0 && this.alertsData[category].warnings === 0) {
        delete this.alertsData[category];
      }
    });
  }

  ngOnDestroy(): void {
    this.alertsRequest?.unsubscribe();
  }
}
